module.exports = __webpack_public_path__ + "img/dashboard-mockup-1.3a4a6f78.png";